import Blog_50_10_container from "./container/Blog_50_10_container";
export default Blog_50_10_container;
